<template>
    <v-container class="d-flex flex-column login-container justify-center align-center">
        <login-view @logged-in="onLoggedIn"/>
    </v-container>
</template>

<script>
import LoginView from '@/views/LoginView'

export default {
    name: 'LoginPage',

    components: {
        LoginView
    },

    methods: {
        onLoggedIn () {
            const backRoute = this.$route.query.backRoute

            if (backRoute) {
                this.$router.push(backRoute)
            } else {
                this.$router.push({
                    name: 'Home'
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.login-container {
    height: 100vh;
}
</style>
